// extracted by mini-css-extract-plugin
export var section = "ExternalArticlesSection-module--section--22ad6";